import idCard from "idcard"

export function isIdcard(value) {
  return idCard.verify(value)
}

export function isPhone(value) {
  const reg = new RegExp(/^1[3-9]\d{9}$/)
  return reg.test(value)
}

/** 座机校验 */
export function isLangLine(value) {
  // 是否存在区号
  const hadCode = value.split("-").length === 2
  const reg = hadCode
    ? new RegExp(/^0\d{2,4}-\d{7,8}$/)
    : new RegExp(/^\d{7,8}$/)
  return reg.test(value)
}

/** 邮箱校验 */
export function isEmail(value) {
  const reg = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
  return reg.test(value)
}
